import { render, staticRenderFns } from "./ViewBadge.vue?vue&type=template&id=3c51b48c&scoped=true&"
import script from "./ViewBadge.vue?vue&type=script&lang=js&"
export * from "./ViewBadge.vue?vue&type=script&lang=js&"
import style0 from "./ViewBadge.vue?vue&type=style&index=0&id=3c51b48c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c51b48c",
  null
  
)

export default component.exports